import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import "./style.scss";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const Roles = (p) => {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const searchState = { data: "" };
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilter] = useState({
    page: 1,
    count: 50,
    search: "",
    catType: "",
  });

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data })
    getData({ search: searchState.data, page: 1 })
  }, [])

  const getData = (p = {}) => {
    loader(true);
    let filter = { ...filters, ...p };
    ApiClient.get("role/listing", filter).then((res) => {
      if (res.success) {
        setData(res.data.filter((itm) => itm?.name != "admin"))
        setTotal(res.total - 1)
      }
      else {
        toast?.error(res?.message)
      }
      loader(false)
    });
  };

  const clear = () => {
    let f = {
      search: "",
      status: "",
    };
    setFilter({ ...filters, ...f });
    getData(f);
  };

  const ChangeStatus = (e) => {
    setFilter({ ...filters, status: e, page: 1 });
    getData({ status: e, page: 1 });
  };

  const statusChange = (itm) => {
    if(itm?.name == "sub admin") return
    let status = "active";
    if (itm.status == "active") status = "deactive";
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status == "active" ? "Activate" : "Deactivate"
        } this role.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.put(`role/status/change`, { id: itm?._id || itm?.id, status }).then(
          (res) => {
            if (res.success) {
              getData();
            }
            loader(false);
          }
        );
      }
    });
  };

  const deleteItem = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this role.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`role/delete?id=${id}`).then((res) => {
          if (res.success) {
            toast?.success(res?.message)
            clear();
          }
          else {
            toast?.error(res?.message)
          }
          loader(false);
        });
      }
    });
  };

  const view = (id) => {
    history(`/roles/detail/${id}`);
  };

  const edit = (id) => {
    history(`/roles/edit/${id}`);
  };

  const isAllow = (key = "") => {
    if(user?.role?.name == "admin") return true
    let permissions = user?.role?.permissions?.[0]
    let value = permissions?.[key]
    return value;
  };

  return (
    <>
      <Html
        clear={clear}
        view={view}
        isAllow={isAllow}
        edit={edit}
        ChangeStatus={ChangeStatus}
        deleteItem={deleteItem}
        filters={filters}
        data={data}
        total={total}
        statusChange={statusChange}
        user={user}
      />
    </>
  );
};

export default Roles;
